import { render, staticRenderFns } from "./OrganizationSingle.vue?vue&type=template&id=2d88b53b&"
import script from "./OrganizationSingle.vue?vue&type=script&lang=js&"
export * from "./OrganizationSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports